import { ru } from './ru.js';
import { kk } from './kk.js';
export const LOCALES = ['ru', 'kk'];
const DICTIONARIES = { ru, kk };
export function getContent(locale) {
    return DICTIONARIES[locale];
}
export function isLocale(value) {
    return typeof value === 'string' && LOCALES.includes(value);
}
/** Подставляет {ключ} в шаблон. Отсутствующий параметр оставляет плейсхолдер видимым. */
export function format(template, params) {
    if (!params)
        return template;
    return template.replace(/\{(\w+)\}/g, (whole, key) => key in params ? String(params[key]) : whole);
}
/**
 * Название сферы, к которой относится зона: условие, ось или развилка.
 *
 * Отчёт собирается кодами, а названия живут в словарях, поэтому разворачивать
 * их приходится и на экране, и в PDF. Держим разворот здесь, в одном месте:
 * две копии этой функции разошлись бы, и PDF начал бы врать по сравнению с
 * сайтом. Неизвестный код отдаём как есть — пустое место хуже кода.
 */
export function subjectTitle(subject, content) {
    if (!subject)
        return null;
    if (subject.kind === 'cond')
        return content.conditions[subject.id]?.title ?? subject.id;
    if (subject.kind === 'axis')
        return content.axes[subject.id]?.name ?? subject.id;
    return content.forks[subject.id]?.title ?? subject.id;
}
/** Параметры зоны: коды сфер внутри них тоже заменяются названиями. */
export function zoneParams(params, content) {
    if (!params)
        return {};
    const out = { ...params };
    if (typeof params.cond === 'string') {
        out.cond = content.conditions[params.cond]?.title ?? params.cond;
    }
    if (typeof params.axis === 'string') {
        out.axis = content.axes[params.axis]?.name ?? params.axis;
    }
    if (typeof params.fork === 'string') {
        out.fork = content.forks[params.fork]?.title ?? params.fork;
    }
    return out;
}
/**
 * Готовая формулировка зоны на языке словаря.
 *
 * Код принимаем строкой, а не ZoneCode: по проводу зона приходит проверенной
 * zod-схемой, где код — обычная строка. Неизвестный код показываем как есть —
 * это заметнее пустой строки и не роняет страницу.
 */
export function zoneText(zone, content) {
    if (!zone.code)
        return '';
    return format(content.zones[zone.code] ?? zone.code, zoneParams(zone.params, content));
}
export { ru, kk };
export { PUSH_TYPES } from './types.js';
//# sourceMappingURL=index.js.map